var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{staticStyle:{"height":"75%"}},[_c('v-progress-circular',{staticClass:"mx-auto",attrs:{"color":"primary","size":"96","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }